import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../../../ui/src/component/icon';
import { PlaylistItem } from '../playlistItem';
import { Modal } from './../../../ui/src/component/modal';
import { getProp } from '../../../ui/src/utilities';
import './onAirPlaylist.css';

class OnAirPlaylist extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalOpened: false,
      youtubeUrl: null,
      youtubeTitle: null,
    };
  }

  render() {
    return (
      <div className="on-air-playlist">
        <a href="/playlist#play" target="_blank">
          <header className="clearfix">
            <button className="ls-button">
              <Icon name="play" size="md" />
            </button>
            <strong className="on-air">ON AIR</strong>
          </header>
        </a>
        <div className="playlist">
          <a href="/playlist#play" className="arrow" target="_blank">{null}</a>
          <div className="cover" />
          {getProp(this.props, 'items', []).map((item, idx) => {
            return (
              <div key={idx}>
                <PlaylistItem
                  item={item}
                  active={idx === 0}
                  onClickYoutube={youtubeObject => {
                    this.setState({
                      modalOpened: true,
                      youtubeUrl: youtubeObject.embedurl,
                      youtubeTitle: youtubeObject.title,
                    });
                  }}
                />
                {idx !== this.props.items.length - 1 ? <hr /> : null}
              </div>
            );
          })}
        </div>
        <Modal
          show={this.state.modalOpened}
          onHide={() => {
            this.setState({ modalOpened: false });
          }}
        >
          {this.state.modalOpened && (
            <div>
              <div className="modal-header">
                <button
                  type="button"
                  onClick={() => this.setState({ modalOpened: false })}
                  className="close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <h4 className="modal-title">{this.state.youtubeTitle}</h4>
              </div>
              <div className="modal-body">
                <iframe
                  title="youtube-video"
                  width="560"
                  height="315"
                  src={`${this.state.youtubeUrl}?autoplay=1`}
                  allowFullScreen={1}
                  frameBorder={0}
                />
              </div>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

OnAirPlaylist.propTypes = {
  items: PropTypes.array,
};

OnAirPlaylist.defaultProps = {
  items: [],
};

export default OnAirPlaylist;



// WEBPACK FOOTER //
// ./src/app/component/onAirPlaylist/onAirPlaylist.js